import Main from './Main';

// mediator
import mediator from './services/shared/mediator';

/** Styles * */
import './styles/app.scss';

console.info('Sofia Health');

/**
 * Import a module dynamically based on its name.
 * This function is used to load components dynamically.
 * @param {string} moduleName
 * @returns {object}
 * @info All components need to be registered here explicitly so they can be picked up by webpack.
 */
const moduleFactory = async (moduleName) => {
  switch (moduleName) {
    case 'AccordianContainer':
      return (await import('./components/AccordianContainer')).default;
    case 'AddTemplate':
      return (await import('./components/AddTemplate')).default;
    case 'BookSession':
      return (await import('./components/BookSession')).default;
    case 'CalendarSync':
      return (await import('./components/CalendarSync')).default;
    case 'Carousel':
      return (await import('./components/Carousel')).default;
    case 'CarouselContainer':
      return (await import('./components/CarouselContainer')).default;
    case 'CategoryContainer':
      return (await import('./components/CategoryContainer')).default;
    case 'CookieBanner':
      return (await import('./components/CookieBanner')).default;
    case 'GroupSessionForm':
      return (await import('./components/GroupSessionForm')).default;
    case 'Form':
      return (await import('./components/Form')).default;
    case 'Header':
      return (await import('./components/Header')).default;
    case 'ImagePreview':
      return (await import('./components/ImagePreview')).default;
    case 'ImageSelector':
      return (await import('./components/ImageSelector')).default;
    case 'LazyLoadContainer':
      return (await import('./components/LazyLoadContainer')).default;
    case 'LazyLoadToDOM':
      return (await import('./components/LazyLoadToDOM')).default;
    case 'ModalsContainer':
      return (await import('./components/ModalsContainer')).default;
    case 'NumberInput':
      return (await import('./components/NumberInput')).default;
    case 'Preloader':
      return (await import('./components/Preloader')).default;
    case 'Search':
      return (await import('./components/Search')).default;
    case 'SignUpForm':
      return (await import('./components/SignUpForm')).default;
    case 'StripeFinishPaymentMethod':
      return (await import('./components/StripeFinishPaymentMethod')).default;
    case 'PractitionerSignUp':
      return (await import('./components/PractitionerSignUp')).default;
    case 'PractitionerSetup':
      return (await import('./components/PractitionerSetup')).default;
    case 'SortableContainer':
      return (await import('./components/SortableContainer')).default;
    case 'Trigger':
      return (await import('./components/Trigger')).default;
    case 'LoginRegisterModal':
      return (await import('./components/LoginRegisterModal')).default;
    default:
      console.warn(`Module ${moduleName} not found`);
      return null;
  }
};

const core = new Main(moduleFactory);
core.init();

window.refreshModules = () => core.refresh();
window.mediator = mediator; // add mediator to global scope for legacy code
